export default "__VITE_ASSET__BNstKCBC__"